import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useUsersStore} from "../../store/users.store";

export const useUserRoleSchema = () => {
    const setRoleSchema = useUsersStore((state) => state.setRoleSchema);

    return useMutation(PartnerApi.usersRoleSchema, {
        onSuccess: (data) => {
            setRoleSchema(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};